import { useState } from 'react'
import { Campo } from '../../componentes/form/campo'
import { Button } from '@mui/material'
import Camera from '../../componentes/gerais/Camera'

export default function Playground() {
	return <div className='p-3'>
		<Camera func={() => alert("teste da camera")} />
	</div>
}